<template>
    <div id="user_faq">
        <!-- <div class="top_title fixed">帮助中心</div> -->
        <ul class="faq_list">
            <li class="faq_item" v-for="(item, i) in faqList" :key="i" @click="gotoFaqDetail(item.id)">
                <span>{{ item.title }}</span>
                <van-icon name="arrow" />
            </li>
        </ul>
        <!-- <div class="faq_fix_bottom">
            <div class="faq_item" @click="gotokefu">
                <span>联系客服</span>
                <van-icon name="arrow" />
            </div>
        </div> -->
    </div>
</template>
<script>
    export default {
        data() {
            return {
                faqList: [],
            };
        },
        mounted() {
            this.getFaqList();
        },
        methods: {
            test() {
                document.getElementsByClassName('scrollbar')[0].scrollTop = 0
            },
            getFaqList() {
                this.$Ajax("faq/faq-list").then(rs => {
                    if (rs.code == 200) {
                        this.faqList = rs.data;
                    }
                });
            },
            gotoFaqDetail(id) {
                this.$router.push({
                    name: "faq.detail",
                    query: {
                        id
                    },
                });
            }
        },
    };
</script>
<style lang="less" scoped>
    #user_faq {
        .faq_list {
            padding-top: 1.5rem;
        }
        .faq_item {
            padding: 1rem 1rem 1rem 2rem;
            margin-bottom: 1rem;
            background-color: #fff;
            border-radius: 0.4rem;
            word-break: break-all;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            span {
                padding-right: 1.2rem;
                flex: 1;
                word-break: break-all;
                font-size: 1.5rem;
            }

            .van-icon {
                font-size: 2.2rem;
                color: #aaa;
            }

            &:hover {
                color: var(--theme);

                .van-icon {
                    color: var(--theme);
                }
            }
        }

        .faq_fix_bottom {
            position: fixed;
            bottom: 5.8rem;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            max-width: 525px;
            padding: 1.2rem;
            background-color: var(--innerbgc);
        }
    }
</style>